import React from "react";
import { Link } from "react-router-dom";
import {
  MdVisibility,
  MdTouchApp,
  MdPeople,
  MdFavorite,
  MdAttachMoney,
  MdChevronRight,
} from "react-icons/md";
import Card, { CardHeader } from "components/card";
import Button from "components/button";
import Skeleton from "components/skeleton/Skeleton";
import { formatNumber } from "utils/format";
import CardError from "./CardError";

const metrics = [
  { key: "pageViews", label: "Page Views", icon: MdVisibility },
  { key: "linkClicks", label: "Link Clicks", icon: MdTouchApp },
  { key: "visitorSubmissions", label: "Visitor Submissions", icon: MdPeople },
  { key: "prayerRequests", label: "Prayer Requests", icon: MdFavorite },
  { key: "donationsCompleted", label: "Donations", icon: MdAttachMoney },
];

const LinkHubSummary = ({ data, loading, error, onRetry }) => {
  const renderBody = () => {
    if (error) {
      return <CardError title="Couldn't Load Link Hub Analytics" error={error} onRetry={onRetry} />;
    }

    return (
      <dl className="divide-y divide-line" aria-busy={loading || undefined}>
        {metrics.map(({ key, label, icon: Icon }) => (
          <div key={key} className="flex items-center justify-between gap-4 py-2.5">
            <dt className="flex items-center gap-2 text-sm text-fg">
              <Icon aria-hidden="true" className="h-4 w-4 text-fg-muted" />
              {label}
            </dt>
            <dd className="text-sm font-semibold text-fg">
              {loading ? <Skeleton className="h-4 w-12" /> : formatNumber(data?.[key] || 0)}
            </dd>
          </div>
        ))}
      </dl>
    );
  };

  return (
    <Card padding="md" className="gap-2">
      <CardHeader
        title="Link Hub Analytics"
        description="Last 30 days"
        actions={
          <Button
            as={Link}
            to="/admin/connect/analytics"
            variant="ghost"
            size="sm"
            rightIcon={<MdChevronRight aria-hidden="true" className="h-4 w-4" />}
          >
            View All
          </Button>
        }
      />
      {renderBody()}
    </Card>
  );
};

export default LinkHubSummary;
